import { HTTP_STATUS, isApiError, isErrorEnvelopeBody } from '@brightlocal/api-client';

import { isTemplateGoneError } from './templateGoneError';
import { TEMPLATE_FORM_FIELDS } from '../consts';

// Form field of each request field the API can name in a validation error
const FORM_FIELD_BY_API_FIELD = {
  name: TEMPLATE_FORM_FIELDS.NAME,
  content: TEMPLATE_FORM_FIELDS.CONTENT,
  review_rating_type: TEMPLATE_FORM_FIELDS.RATING
} as const;

const isTemplateApiField = (field: string): field is keyof typeof FORM_FIELD_BY_API_FIELD =>
  Object.keys(FORM_FIELD_BY_API_FIELD).includes(field);

/** The form fields a `400` names; empty for any other failure. The API's message isn't shown, as its wording can change. */
export const getTemplateErrorFields = (error: unknown) => {
  const isValidationError =
    isApiError(error) && error.status === HTTP_STATUS.VALIDATION_ERROR && isErrorEnvelopeBody(error.error);

  if (!isValidationError) {
    return [];
  }

  return (error.error.details ?? []).flatMap(({ field }) =>
    field !== undefined && isTemplateApiField(field) ? [FORM_FIELD_BY_API_FIELD[field]] : []
  );
};

interface HandledSaveErrorParams {
  /** The failed save. */
  error: unknown;
  /** The save was an Edit; on Create a `404` or `403` is an ordinary failure. */
  isEdit: boolean;
}

/** The sheet answers this failure itself: a gone template on Edit closes it, and field errors show on their fields. */
export const isHandledTemplateSaveError = ({ error, isEdit }: HandledSaveErrorParams) =>
  (isEdit && isTemplateGoneError(error)) || getTemplateErrorFields(error).length > 0;
